import { type HttpResponse, http, handleHttpRequest } from 'interfaces'
import { type PersonUrl } from 'services'

export async function createPersonUrl (url: PersonUrl): Promise<number> {
  const urlPath = `/api/v1/people/${url.personId}/url/`
  return await http.post(urlPath, url, { withCredentials: true })
    .then((value) => { return value.data.result.id })
    .catch(() => { return 0 })
}

export async function updatePersonUrl (url: PersonUrl): Promise<boolean> {
  const urlPath = `/api/v1/people/${url.personId}/url/${url.id}/`

  return await http.put(urlPath, url, { withCredentials: true })
    .then(() => { return true })
    .catch(() => { return false })
}

export async function deletePersonUrl (url: PersonUrl): Promise<boolean> {
  const urlPath = `/api/v1/people/${url.personId}/url/${url.id}/`
  return await http.delete(urlPath, { withCredentials: true })
    .then(() => { return true })
    .catch(() => { return false })
}

export async function patchPersonUrlDisplayOrder (personId: number, typeOfDataSource: string, personUrlsById: Record<number, number>, urlSelected: number): Promise<HttpResponse<PersonUrl[]>> {
  return await handleHttpRequest(http.patch(`/api/v1/people/${personId}/url/`, {
    idAndDisplayOrderMap: personUrlsById,
    type: typeOfDataSource,
    urlIdSelected: urlSelected
  }))
}
